const jobDetail = {
  Title: '#{neighborhood}, #{city} - #{clientName}',
  TitleLanguages: '#{languages} - #{clientName}',
  TitleClientOnly: '#{clientName}',
  Loading: 'Loading job details...',
  DenyApplication: 'Deny',
  AcceptApplication: 'Accept',
  AcceptAndAdd: 'Accept & add',
  AcceptAndAddToRosterTitle: 'Accept application & add to #{clientName}\'s roster',
  ThisClient: 'this client',
  AcceptWarning: {
    Title: 'Accept this application?',
    CaregiverNotActive: 'This caregiver is not active.',
    NoRegisteredClient: 'This job has no registered client, so they can\'t be added to a roster — it will just be marked accepted.',
    AcceptAnyways: 'Accept anyways',
  },
  Accepted: 'Accepted',
  Pending: 'Pending',
  Denied: 'Denied',
  Rejected: 'Rejected',
  EmptyApplications: 'There are no applications here yet.',
  CaregiverQuickView: {
    LoadError: 'The caregiver profile could not be loaded. Please try again.',
    NoProfileInformation: 'No profile information is available.',
  },
  Tabs: {
    InternalApplications: 'Internal Applications (P:#{p} A:#{a} R:#{r})',
    Information: 'Information',
    Messages: 'Messages',
    NearbyCaregivers: 'Nearby Caregivers (#{count} within #{radius} km radius)',
    NearbyCaregiversSearch: 'Nearby Caregivers (#{count})',
    Candidates: 'Candidates (#{count} within #{radius} km)',
    Invitations: 'Invitations (#{count})',
  },
  NearbyCaregivers: {
    Application: {
      ACCEPTED: 'Accepted',
      NOT_APPLIED: 'Not applied',
      PENDING: 'Applied',
      REJECTED: 'Denied',
    },
    CanTravel: {
      false: 'No',
      null: 'N/A',
      true: 'Yes',
    },
    CityDistance: '#{city} - #{distance} km',
    Columns: { // in order of rendering
      Picture: 'Picture',
      Name: 'Name',
      Location: 'City and distance',
      Phone: 'Phone number',
      ProfileStatus: 'Profile status',
      Languages: 'Languages',
      Certifications: 'Certifications',
      Considerations: 'Considerations',
      CanTravel: 'Can travel',
      Application: 'Application',
      InitialEmail: 'Initial outreach',
    },
    Distance: '#{distance} km away',
    Empty: 'There are no caregivers within this radius.',
    Radius: 'Radius',
    RadiusOption: '#{radius} km',
    RequireAllLanguages: 'Require all selected languages',
    Requirement: {
      false: 'Not met',
      null: 'None',
      true: 'Met',
      undefined: 'N/A',
    },
    Status: {
      NotAvailable: 'Not available',
    },
    InitialOutreach: {
      NotSent: 'Not sent',
      EmailSentAt: '#{date}',
    },
    RecruitingOutreach: {
      Action: 'Create outreach',
      EmailMessage: 'Email message',
      EmailSubject: 'Email subject',
      Errors: {
        Email: 'Email was not sent to #{caregiverName}: #{reason}',
        NoMessage: 'No outreach message was sent to #{caregiverName}.',
        PhoneNumber: 'Could not send outreach to #{caregiverName}: no valid phone number is available.',
        PhoneNumberMismatch: 'Could not send outreach to #{caregiverName}: the existing phone number does not match the number in the caregiver profile.',
        Sms: 'SMS was not sent to #{caregiverName}: #{reason}',
      },
      GenerateError: 'The outreach draft could not be generated. Please try again.',
      Generating: 'Generating email and SMS drafts...',
      Preview: 'Message preview',
      Recipients: 'This email and SMS will be sent to #{count} selected caregivers.',
      Regenerate: 'Regenerate',
      Footer: '#{name} will be replaced with the caregiver\'s name on send',
      Send: 'Send email and SMS',
      SmsMessage: 'SMS message',
      Title: 'Initial caregiver outreach',
    },
  },
  Candidates: {
    Radius: 'Radius (km)',
    Send: 'Send invitations (#{count})',
    NotActive: 'You can send invitations only for an active job.',
    Empty: 'There are no caregivers within #{radius} km.',
    UnlocatedTitle: 'No home location (#{count})',
    SelectAll: 'Select all caregivers',
    DeselectAll: 'Deselect all caregivers',
    Select: 'Select #{name}',
    Columns: {
      Caregiver: 'Caregiver',
      Distance: 'Distance',
      Languages: 'Languages',
      CareNeeds: 'Care needs',
      Availability: 'Availability',
      Travel: 'Travel',
      Interviews: 'Onboarding interviews',
      Invitation: 'Invitation',
    },
    Distance: '#{distance} km',
    NoDistance: 'Not known',
    NoPhone: 'No phone number',
    Slots: '#{covered} of #{total} slots',
    Interviewed: 'interviewed',
    MaxTravelTime: 'Up to #{time}',
    NotGiven: 'Not given',
    None: 'None',
    Interview: 'Interview',
    CanInvite: 'Can be invited',
    BlockedReasons: {
      ALREADY_INVITED: 'Already invited',
      NO_PHONE_NUMBER: 'No phone number',
    },
    Errors: {
      400: 'The radius must be from 1 to 50 km.',
      404: 'This job was not found. Reload the page.',
      409: 'Loom cannot find the job address on the map. Check the home address of the client.',
      Default: 'The candidates could not be loaded. Try again.',
    },
    InvitationDialog: {
      Title: 'Send interview invitations',
      CallNow: 'The first call goes out now.',
      CallToday: 'The first call goes out today at 9 AM, Toronto time.',
      CallTomorrow: 'The first call goes out tomorrow at 9 AM, Toronto time.',
      Send: 'Send',
      Retry: 'Try again (#{count})',
      Sending: 'Sending #{done} of #{total}',
      Pending: 'Not sent',
      Sent: 'Sent',
      Errors: {
        CGR_001: 'The caregiver was not found.',
        INV_002: 'The caregiver already has an invitation for this job.',
        INV_003: 'Loom did not accept the request.',
        INV_006: 'The caregiver is not active.',
        INV_007: 'The caregiver has no phone number.',
        INV_009: 'Loom saved the invitation, but the call did not start. Try again.',
        JOB_001: 'The job was not found.',
        JOB_011: 'The job is not active.',
        Default: 'Something went wrong. Try again.',
      },
    },
  },
  Invitations: {
    Empty: 'No invitations were sent for this job.',
    Columns: {
      Caregiver: 'Caregiver',
      Status: 'Status',
      Progress: 'Progress',
      Sent: 'Sent',
      Closed: 'Closed',
      Details: 'Details',
    },
    Status: {
      WAITING: 'Waiting',
      COMPLETED: 'Completed',
      DECLINED: 'Declined',
      UNREACHABLE: 'Unreachable',
      CANCELLED: 'Cancelled',
    },
    Progress: {
      STARTING: 'Starting',
      AWAITING_REPLY: 'Waiting for a reply',
      CALL_BOOKED: 'Call booked',
      IN_REVIEW: 'In review',
      CLOSED: 'Closed',
    },
    DeclineReason: 'Reason: #{reason}',
    DoNotContact: 'Asked not to be contacted',
    Cancel: 'Cancel invitation',
    CancelTitle: 'Cancel the invitation',
    CancelConfirm: 'Cancel the invitation for #{name}? You cannot invite this caregiver to this job again.',
    Keep: 'Keep invitation',
    Errors: {
      INV_001: 'This invitation was not found.',
      INV_008: 'This invitation is already closed.',
      Load: 'The invitations could not be loaded. Try again.',
      Default: 'The invitation could not be cancelled. Try again.',
    },
  },
  InterviewQuestions: {
    Title: 'Family interview questions',
    Edit: 'Edit',
    Empty: 'There are no family questions for this job.',
    Dialog: {
      Title: 'Edit family interview questions',
      Note: 'The interview call asks these questions in this order. You can add up to #{max}. Changes apply to every call that has not started.',
      Question: 'Question #{number}',
      Delete: 'Delete question #{number}',
      Add: 'Add question',
    },
    Errors: {
      Load: 'The family questions could not be loaded. Try again.',
      JOB_001: 'This job was not found. Reload the page.',
      JOB_003: 'Loom did not accept the questions. Each question must have 1 to 200 characters.',
      Default: 'The family questions could not be saved. Try again.',
    },
  },
  Messages: {
    Empty: 'There are no messages here yet.',
    LoadMore: 'Load More',
    Header: {
      LastAnnouncement: 'Last announcement',
    },
    Sort: {
      NewestFirst: 'Newest first',
      OldestFirst: 'Oldest first',
    },
    Type: {
      Comments: 'Comment',
      Announcements: 'Announcements',
    },
    FilterPills: {
      All: 'All',
    },
    Timestamp: {
      AnnouncedOn: 'Announced on',
      PostedOn: 'Posted on',
    },
    NewMessage: {
      Comments: 'Comment',
      Announcements: 'Announce',
      Cancel: 'Cancel',
      AddACommentOrAnnouncement: 'Add a comment or announcement...',
    },
    Feed: {
      Titles: {
        AnnouncementPosted: 'Announcement posted',
        CommentAdded: 'Comment added',
      },
      RelativeTime: {
        Today: 'Today',
        Now: 'Now',
        MinutesAgo: '#{count} min ago',
        HoursAgo: '#{count} hr ago',
      },
    },
  },
  Day: {
    SU: 'Sunday',
    MO: 'Monday',
    TU: 'Tuesday',
    WE: 'Wednesday',
    TH: 'Thursday',
    FR: 'Friday',
    SA: 'Saturday',
  },
  Summary: {
    Languages: 'Languages: #{count}/#{total}',
    Certifications: 'Certifications: #{count}/#{total}',
    Considerations: 'Considerations: #{count}/#{total}',
    CanTravel: 'Can Travel: #{value}',
    Yes: 'Yes',
    No: 'No',
  },
  Metrics: {
    ClientName: 'Client Name',
    Priority: 'Priority',
    StartDate: 'Start Date',
  },
  ConfirmAcceptTitle: 'Confirm Accept',
  ConfirmAcceptText: 'Are you sure you want to accept #{name} for this job?',
  Details: {
    Languages: 'Languages',
    Certifications: 'Certifications',
    Considerations: 'Considerations',
    AdditionalConsiderations: 'Additional Considerations',
    Travel: 'Travel',
    CanTravelToLocation: 'Can Travel To Location: #{value}',
    ScheduleAvailability: 'Schedule Availability',
  },
  Information: {
    AboutThisRole: 'About this role',
    ClientFor: 'Client for this position',
    Description: 'Description',
    Schedule: 'Schedule',
    StartDate: 'Expected start date',
    Compensation: 'Compensation',
    FlexibleStartTiming: 'Flexible start timing',
    CareNeeds: 'Care needs',
    SpecialConsiderations: 'Special considerations',
    AdditionalConsiderations: 'Additional considerations',
    NoSpecificRequirements: 'No specific requirements',
    NoSpecialConsiderations: 'No special considerations',
    WeeklyEarnings: '$#{amount}/week',
    BasedOnHours: 'Based on #{hours} hours/week',
    WeeklyHours: '#{hours} hours/week',
    WeeklyEarningsVaries: 'Varies',
    WeeklyHoursVary: 'Hours vary week to week',
    HourlyRate: '$#{rate}/hr',
    Priorities: 'Priorities',
    Requirements: 'Requirements',
    LocationDisplay: '#{neighborhood}, #{city}',
    LiveIn: 'Live-in',
    Flexible: 'Flexible schedule',
    JobURL: 'Job Application URL',
    CarePlan: {
      MOBILITY_SUPPORT: {
        Label: 'Mobility support',
        Description: 'Help with walking, transfers, or getting around',
      },
      MEDICATION_REMINDERS: {
        Label: 'Medication reminders',
        Description: 'Ensuring medications are taken on time',
      },
      MEAL_PREP: {
        Label: 'Meal prep',
        Description: 'Preparing nutritious meals and snacks',
      },
      LIGHT_HOUSEKEEPING: {
        Label: 'Light housekeeping',
        Description: 'Basic cleaning and tidying up',
      },
      TRANSPORTATION: {
        Label: 'Transportation',
        Description: 'Driving to appointments and errands',
      },
      COMPANIONSHIP: {
        Label: 'Companionship',
        Description: 'Social interaction and emotional support',
      },
      PERSONAL_CARE: {
        Label: 'Personal care',
        Description: 'Assistance with bathing, grooming, and dressing',
      },
      MEDICAL_APPOINTMENTS: {
        Label: 'Medical appointments',
        Description: 'Accompanying to and from medical visits',
      },
      SHOPPING_ASSISTANCE: {
        Label: 'Shopping assistance',
        Description: 'Help with grocery shopping and errands',
      },
      PET_CARE: {
        Label: 'Pet care',
        Description: 'Feeding, walking, and caring for pets',
      },
    },
    CertificationsOptions: {
      PSW: 'Personal Support Worker (PSW)',
      DSW: 'Developmental Service Worker (DSW)',
      PAB: 'Préposé aux bénéficiaires (PAB)',
      CNA: 'Certified Nursing Assistant (CNA)',
      HCA: 'Health Care Aide (HCA)',
      RNA: 'Registered Nursing Assistant (RNA)',
      RPN: 'Registered Practical Nurse (RPN)',
      RN: 'Registered Nurse (RN)',
      CPR: 'CPR Certification',
      FIRST_AID: 'First Aid Certification',
      PSW_STUDENT: 'PSW Student',
      NURSING_STUDENT: 'Nursing Student',
    },
    LanguageOptions: {
      ENGLISH: 'English',
      FRENCH: 'French',
      CHINESE: 'Chinese',
      HINDUSTANI: 'Hindustani',
      SPANISH: 'Spanish',
      PUNJABI: 'Punjabi',
      ARABIC: 'Arabic',
      TAGALOG: 'Tagalog',
      ITALIAN: 'Italian',
      GERMAN: 'German',
      PORTUGUESE: 'Portuguese',
      PERSIAN: 'Persian',
      RUSSIAN: 'Russian',
      TAMIL: 'Tamil',
      VIETNAMESE: 'Vietnamese',
      GUJARATI: 'Gujarati',
      POLISH: 'Polish',
      KOREAN: 'Korean',
      SERBO_CROATIAN: 'Serbo-Croatian',
      GREEK: 'Greek',
      HAITIAN_CREOLE: 'Haitian Creole',
      UKRAINIAN: 'Ukrainian',
      BENGALI: 'Bengali',
      ROMANIAN: 'Romanian',
      DUTCH: 'Dutch',
      CREE: 'Cree',
      JAPANESE: 'Japanese',
      HEBREW: 'Hebrew',
      TURKISH: 'Turkish',
      MALAYALAM: 'Malayalam',
      LITHUANIAN: 'Lithuanian',
      ILOCANO: 'Ilocano',
      SOMALI: 'Somali',
      SWAHILI: 'Swahili',
      TELUGU: 'Telugu',
      MANDARIN: 'Mandarin',
      CANTONESE: 'Cantonese',
      HINDI: 'Hindi',
    },
    ConsiderationsOptions: {
      COMFORTABLE_WITH_PETS: 'Comfortable working around pets',
      COMFORTABLE_WITH_STAIRS: 'Comfortable with stairs',
      NON_SMOKING_HOUSEHOLD: 'Non-smoking household preferred',
      PHYSICAL_LIFTING_REQUIRED: 'Physical lifting may be required',
      DEMENTIA_ALZHEIMER_EXPERIENCE: 'Experience with dementia/Alzheimer\'s',
      FLEXIBLE_SCHEDULE_CHANGES: 'Flexible with schedule changes',
    },
  },
  Settings: {
    SettingsDescription: 'Job settings',
    Contact: {
      Title: 'Contact information',
      Description: 'Manage who can see your contact details',
    },
  },
  ChangeStatusDialog: {
    Title: 'Change job status',
    Status: 'Status',
  },
  Status: {
    ACTIVE: 'active',
    INACTIVE: 'inactive',
  },
  Evaluation: {
    Unknown: 'Unknown',
    Success: 'Success',
    Failure: 'Failure',
  },
  ExternalApplications: {
    Email: 'Email',
    Phone: 'Phone',
    Evaluation: 'Evaluation',
    Basic: 'Basic Qualification: #{label}',
    Communication: 'Communication: #{label}',
    Motivation: 'Motivation: #{label}',
    Biography: 'Biography',
    ShortBio: 'Short Bio',
    PersonalBio: 'Personal Bio',
    CaregiverMotivation: 'Caregiver Motivation',
    ContactInfo: 'Contact Information',
    FirstName: 'First Name',
    LastName: 'Last Name',
    Street: 'Street Address',
    City: 'City',
    Province: 'Province',
    PostalCode: 'Postal Code',
    DataCollection: 'Data Collection',
    Value: 'Value',
    Rationale: 'Rationale',
    EvaluationTitle: 'Evaluation',
    ScreeningStatus: 'Screening Status',
    ScreeningStatusLabel: 'Screening: #{label}',
    BasicEval: 'Basic Qualification',
    CommunicationEval: 'Communication Skills',
    MotivationEval: 'Motivation & Commitment',
    Status: 'Status',
    Description: 'Description',
    ConversationUrl: 'Conversation URL',
    NoInterviewData: 'No interview data available for this application.',
  },
};

export default jobDetail;
